import { ApiModule, NetworkHelper } from '../module/index';
import {
  Order,
  Lang,
  Configurator,
  Booking,
  EPSTest,
  MlAbstractResponse,
} from 'types';
import { map, take } from 'rxjs/operators';
import store from './../../store';
import { Observable } from 'rxjs';

const DEFAULT_LANG = Lang.DEFAULT_LANG();

export namespace OrderService {
  // export const createOrder = (body: Order.Body) => {
  //   const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;
  //   const _body = { ...body.toObject(), locale };
  //   return ApiModule.get()
  //     .workflowApi.post<Order.OrderResponse>('/v1/orders/create', _body)
  //     .pipe(take(1));
  // };

  // export const createOrderV2 = (body: Order.Body) => {
  //   const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;
  //   const _body = { ...body.toObject() };
  //   return ApiModule.get()
  //     .workflowApi.post<Order.OrderResponse>(
  //       '/v2/orders/create',
  //       _body,
  //       NetworkHelper.getUTMParams(),
  //     )
  //     .pipe(take(1));
  // };

  export const createOrder = (request: Order.Ml.Request.Body) => {
    const query = {};

    const testTool: Configurator.State = Configurator.builder();

    if (testTool) {
      const header = testTool?.eps?.getHeaderById(
        EPSTest.HeadersGroupId.registerPayment,
      );

      if (header !== EPSTest.Headers.none) {
        query['expedia_test'] = header;
      }
    }

    return ApiModule.get()
      .apiML.post<{
        data: Order.Ml.Response.Booking;
      }>('/orders', request, query)
      .pipe(map(response => response.data));
  };

  export const proccessOrder = (request: { orderId: string }) => {
    const testTool: Configurator.State = Configurator.builder();

    const query = {};

    if (testTool) {
      const header = testTool?.eps?.getHeaderById(
        EPSTest.HeadersGroupId.createBooking,
      );

      if (header !== EPSTest.Headers.none) {
        query['expedia_test'] = header;
      }
    }

    return ApiModule.get()
      .apiML.post<{
        data: Order.Ml.Response.Booking;
      }>(`/orders/${request.orderId}/book`, {}, query)
      .pipe(map(response => response.data));
  };

  export const completeOrder = (request: { orderId: string }) => {
    const testTool: Configurator.State = Configurator.builder();

    const query = {};

    if (testTool) {
      const header = testTool?.eps?.getHeaderById(
        EPSTest.HeadersGroupId.completePayment,
      );

      if (header !== EPSTest.Headers.none) {
        query['expedia_test'] = header;
      }
    }

    return ApiModule.get()
      .apiML.post<{
        data: Order.Ml.Response.Booking;
      }>(`/orders/${request.orderId}/complete`, {}, query)
      .pipe(map(response => response.data));
  };

  export const getOrder = (orderID: string) => {
    const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;

    return ApiModule.get().workflowApi.get<Order.OrderItem>(
      `/v2/trips/order/data/${orderID}`,
      {
        locale,
      },
    );
  };

  export const cancelOrder = (orderID: string) => {
    const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;
    const testTool: Configurator.State = Configurator.builder();
    const query = testTool
      ? { locale, source_settings: testTool.eps.toRequestBody() }
      : { locale };
    return ApiModule.get().workflowApi.get<Order.OrderCancellationResponse>(
      `/v1/orders/cancel/${orderID}`,
      query,
    );
  };

  export const twoFAProcess = (orderID: string) => {
    const testTool: Configurator.State = Configurator.builder();
    const body = testTool
      ? { product: 'hotel', source_settings: testTool.eps.toRequestBody() }
      : { product: 'hotel' };
    return ApiModule.get().workflowApi.post<Order.OrderResponse>(
      `v2/orders/continue_process/${orderID}`,
      body,
    );
  };

  export namespace ML {
    export const getOrderV2 = (orderId: Order.Ml.Response.Order['id']) => {
      return ApiModule.get()
        .apiML.get<MlAbstractResponse<Order.Ml.Response.OrderDetails>>(
          `/orders/${orderId}`,
        )
        .pipe(map(it => it.data));
    };

    export const cancelOrderV2 = (orderId: Order.Ml.Response.Order['id']) => {
      return ApiModule.get().apiML.delete(`/orders/${orderId}`);
    };
  }
}
